export const MQC_LARGE_PORTRAIT = [
    {
        name: "tablet",
        maxWidth: 1024,
        size: { width: 300, height: 450 },
        multipliers: [1, 2]
    },
    {
        name: "desktop",
        minWidth: 1025,
        size: { width: 438, height: 560 },
        multipliers: [1, 2]
    },
    {
        name: "default",
        size: { width: 438, height: 560 }
    }
];

export const MQC_EPISODE_BANNER = [
    {
        name: 'default',
        size: { width: 606, height: 278 },
        multipliers: [ 1, 2 ]
    }
];

export const MQC_EPISODE_MAP = [
    {
        name: 'default',
        size: { width: 210, height: 120 },
        multipliers: [ 1, 2 ]
    }
];

export const MQC_BANNER = [
    {
        name: 'mobile',
        maxWidth: 415,
        size: { width: 390, height: 220 },
        multipliers: [1, 2]
    },
    {
        name: 'tablet',
        maxWidth: 1024,
        size: { width: 1000, height: 564 },
        multipliers: [1, 2]
    },
    {
        name: 'desktop',
        minWidth: 1025,
        size: { width: 1400, height: 600 },
        multipliers: [1, 2]
    },
    {
        name: 'default',
        size: { width: 1400, height: 600 },
        multipliers: [1]
    }
];

export const MQC_SHOPPABLE_CARD = [
    {
        name: 'mobile',
        maxWidth: 840,
        size: { width: 300 },
        multipliers: [1, 2]
    },
    {
        name: 'tablet',
        maxWidth: 1024,
        size: { width: 311 },
        multipliers: [1, 2]
    },
    {
        name: 'desktop',
        maxWidth: 1200,
        size: { width: 368 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'desktopWide',
        minWidth: 1201,
        size: { width: 430 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'default',
        size: { width: 430 },
        multipliers: [1, 2]
    }
];

export const MQC_LISTICLE = [
    {
        name: 'mobile',
        maxWidth: 415,
        size: { width: 400, height: 234 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'phablet',
        maxWidth: 640,
        size: { width: 616, height: 359 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'desktop-small',
        maxWidth: 1024,
        size: { width: 648, height: 378 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'desktop',
        maxWidth: 1200,
        size: { width: 536, height: 313 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'desktop-default',
        minWidth: 1200,
        size: { width: 648, height: 378 },
        multipliers: [ 1, 2 ]
    },
    {
        name: 'default',
        size: { width: 648, height: 378 }
    }
];